export const listingBookingSettings = {
  section01: {
    title: "Rezerwacje bezpośrednie dla tej oferty",
  },
  motor: {
    activeTitle: "Silnik rezerwacji aktywny",
    inactiveTitle: "Silnik rezerwacji nieaktywny",
    activeDesc: "Goście mogą rezerwować tę ofertę bezpośrednio z jej linku.",
    inactiveDesc: "Rezerwacje bezpośrednie są wyłączone dla tej oferty.",
    statusOn: "Aktywny",
    statusOff: "Nieaktywny",
  },
  payment: {
    title: "Kiedy gość płaci?",
    onArrival: {
      name: "Płatność na miejscu",
      hint: "Rezerwacja bez opłaty, płatność po przyjeździe.",
    },
    online: {
      name: "Płatność online",
      hint: "Płatność przy potwierdzeniu rezerwacji.",
    },
  },
  common: {
    saving: "Zapisywanie…",
    onlyOnlineBadge: "Tylko płatność online",
  },
  hold: {
    title: "Czas blokady",
    desc: "Kalendarz pozostaje zablokowany, dopóki gość nie dokończy płatności.<br>Jeśli nie zapłaci w ustawionym czasie, <strong>dostępność zwalnia się automatycznie</strong>.",
  },
  units: {
    min: "min",
    hour: "godzina",
    hours: "godziny",
  },
  partial: {
    title: "Płatność częściowa",
    cardTitle: "Zezwalaj na opłacenie części przy rezerwacji",
    descOn: "<strong>Włączone.</strong> Gość może zapłacić teraz <strong>{percent}%</strong>, a resztę przed przyjazdem (albo zapłacić całość).",
    descOff: "<strong>Wyłączone.</strong> Gość płaci <strong>całą kwotę</strong> przy rezerwacji.",
    blockTitle: "Reszta płatna w obiekcie",
    blockOn: "<strong>Włączone.</strong> Gość płaci online <strong>tylko {percent}%</strong>; reszta jest płatna <strong>po przyjeździe</strong> (nie może zapłacić całości online).",
    blockOff: "<strong>Wyłączone.</strong> Gość może wybrać, czy zapłaci online {percent}%, czy całą kwotę.",
  },
  reminder: {
    title: "Przypomnienie o dopłacie",
    cardTitle: "Wysyłaj przypomnienie o uregulowaniu pozostałej kwoty",
    daysBefore: "{count} dzień przed | {count} dni przed | {count} dni przed",
    descOn: "<strong>Włączone.</strong> <strong>{daysBefore}</strong> przyjazdem (około 09:00 czasu obiektu) gość dostaje link do opłacenia pozostałej kwoty przez <strong>WhatsApp i e-mail</strong>.",
    descOff: "<strong>Wyłączone.</strong> Gość nie dostaje przypomnienia o opłaceniu pozostałej kwoty online przed przyjazdem.",
    daysLabel: "Dni przed przyjazdem",
    hint: "Wysyłane tylko raz i tylko do gości, którzy mają coś do dopłaty. Jeśli reszta jest płatna w obiekcie, nie jest wysyłane.",
  },
  approve: {
    title: "Zatwierdzanie rezerwacji",
    cardTitle: "Zatwierdzaj każdą rezerwację przed jej potwierdzeniem",
    descOn: "<strong>Włączone.</strong> Każda rezerwacja pozostaje <strong>w oczekiwaniu na zatwierdzenie</strong>: przychodzi powiadomienie, a decyzja o przyjęciu lub odrzuceniu należy do Pana/Pani. Rezerwacja nie zostaje potwierdzona do czasu zatwierdzenia.",
    descOff: "<strong>Wyłączone.</strong> Rezerwacje są <strong>potwierdzane automatycznie</strong> po opłaceniu. Warto włączyć tę opcję, aby osobiście przeglądać i zatwierdzać każde zgłoszenie.",
  },
  toasts: {
    statusUpdatedAll: "Status zaktualizowany we wszystkich jednostkach.",
    statusUpdated: "Status zaktualizowany.",
    statusError: "Nie udało się zaktualizować.",
    paymentUpdated: "Metoda płatności zaktualizowana.",
    paymentError: "Nie udało się zapisać metody płatności.",
    partialUpdated: "Płatność częściowa zaktualizowana.",
    partialError: "Nie udało się zapisać płatności częściowej.",
    reminderUpdated: "Przypomnienie zaktualizowane.",
    reminderError: "Nie udało się zapisać przypomnienia.",
    saved: "Zapisano.",
    saveError: "Nie udało się zapisać.",
    linkCopied: "Link skopiowany.",
    copyError: "Nie udało się skopiować.",
  },
  share: {
    whatsappText: "Dzień dobry 👋 Oto link do rezerwacji: {link}",
  },
};
